import React from "react"
import { BiSearchAlt } from "react-icons/bi"
import MI_Ext from "./_ext"

class MI_search extends MI_Ext {
  renderIcon = () => {
    return <BiSearchAlt />
  }
}
export default MI_search
